import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { getKycImage } from "../logic/attachments";
import { MarriageNameMatchesId } from "../state/types";
import { rv } from "../tokens";
import SegmentedPills from "../ui/fields/SegmentedPills";
import UploadTile from "../ui/UploadTile";
import { StepViewProps } from "./types";

type Props = Pick<StepViewProps, "state" | "handlers">;

const marriageNameOptions: Array<{ label: string; value: MarriageNameMatchesId }> = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

const useStyles = makeStyles((theme) => ({
  wrap: {
    borderTop: `1px solid ${rv.hairline3}`,
    marginTop: theme.spacing(1),
    paddingTop: theme.spacing(2),
  },
  note: {
    color: rv.muted,
    fontSize: 12.5,
    lineHeight: 1.45,
    margin: "6px 0 0",
  },
  upload: { marginTop: theme.spacing(2) },
}));

export default function MarriageCertificateUpload({ state, handlers }: Props) {
  const classes = useStyles();
  const { draft, originalKyc, uploads, errors, marriageNameMatchesId } = state;
  const civilStatus = String(draft.kyc.civil?.civilStatus || "").toLowerCase();
  if (civilStatus !== "married") return null;

  return (
    <Grid item xs={12}>
      <div className={classes.wrap}>
        <SegmentedPills
          label="Does your married name match your name on your valid ID?"
          required
          value={marriageNameMatchesId}
          options={marriageNameOptions}
          error={errors.marriageNameMatchesId}
          onChange={(value) =>
            handlers.setMarriageNameMatchesId(value as MarriageNameMatchesId)
          }
        />
        <p className={classes.note}>
          If it does not match, upload your marriage certificate for review.
        </p>

        {marriageNameMatchesId === "no" && (
          <div className={classes.upload}>
            <UploadTile
              label="Marriage certificate"
              required
              entry={uploads.marriageCert}
              onFileImage={getKycImage(originalKyc, "marriageCert")}
              error={errors.marriageCert}
              onFile={(file) => handlers.uploadFile("marriageCert", file)}
              onRemove={() => handlers.removeUpload("marriageCert")}
            />
          </div>
        )}
      </div>
    </Grid>
  );
}
